module.exports = __webpack_public_path__ + "static/media/mitsl200-4wd.e5c1fdc5.jpg";